import { commitLocalUpdate, useRelayEnvironment } from 'utils/graphClient';
import { authenticatedHttpRequest } from '../http';

export const useRegisterView = () => {
  const env = useRelayEnvironment();

  const registerView = (nodeId: string) => {
    // Delay the internal update of isNew,
    //   Just because it's cool
    setTimeout(() => {
      commitLocalUpdate(env, (store) => {
        const record = store.get(nodeId);
        record?.setValue(false, 'isNew');
      });
    }, 500);

    authenticatedHttpRequest('/graph', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json;charset=UTF-8',
      },
      body: JSON.stringify({
        query: `mutation RegisterTrackingAction_Mutation($input: TrackingRegisterActionMutationInput!) {
              registerTrackingAction(input: $input) {
                success
              }
            }
          `,
        variables: {
          input: {
            action: {
              nodeId,
              action: 'VIEW',
              referralUrl: window.location.href,
            },
          },
        },
      }),
    });
  };

  return registerView;
};
